<nav id="main-nav" class="navbar fixed-top navbar-expand-lg navbar-dark justify-content-between app-top-nav">
  <div class="d-flex align-items-center">
    <button class="btn btn-link text-white me-2 sidebar-toggle-btn" type="button" (click)="onSidebarToggle()"
      [title]="isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
      <fa-icon [icon]="isSidebarCollapsed ? faChevronRight : faChevronLeft"></fa-icon>
    </button>
    <a class="navbar-brand d-flex align-items-center" routerLink="/dashboard">
      <img src="app/assets/images/navbar-logo.png" alt="Milestone" />
    </a>
  </div>

  <div class="navbar-text header-right" *ngIf="loggedIn">
    <div class="user-menu" (click)="toggleUserMenu($event)" [class.open]="userMenuOpen">
      <div class="user-avatar" aria-hidden="true">{{ userInitials }}</div>
      <span class="user-name">{{ displayName }}</span>
      <fa-icon [icon]="faChevronDown" class="user-caret"></fa-icon>

      <div class="user-dropdown" *ngIf="userMenuOpen" (click)="$event.stopPropagation()">
        <button type="button" class="dropdown-item" (click)="logout()">Logout</button>
      </div>
    </div>
  </div>

  <div class="navbar-text" *ngIf="!loggedIn">
    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <a class="nav-link" routerLink="/login">Login</a>
      </li>
    </ul>
  </div>
</nav>
